<script setup lang="ts">
import { sanitizeHtml } from '@/utils/sanitize.ts'

const props = defineProps<{
  title: string
  message: string
}>()
</script>
<template>
  <div class="hover:cursor-pointer">
    <h3 class="font-semibold">{{ title }}</h3>
    <div v-html="sanitizeHtml(message)"></div>
  </div>
</template>
